// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext, useState} from 'react';
import styles from './state_reset_password.module.less';
import styles_common from './form.module.less';
import cn from 'classnames';
import {t_states} from './types';
import Chevron_left from '../../../../hola/pub/img/hola2023/icons/16/chevron_left.svg';
import {is_valid_email} from 'zurl';
import etask from 'zetask';
import {perr} from 'hola_pub_util';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {Input} from '../../../../hola/pub/lib/input';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';

interface i_reset_password_props {
    go_to: (type:t_states, direction?: number)=>void;
    img_set?: 'hola'|'toolip';
}

export const Check_email = (props: i_reset_password_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.root}>
      {props.img_set == 'toolip' && <button
        className={styles_common.back_btn_in_corner} onClick={()=>{
          props.go_to('login_with_email', -1);
        }}><Chevron_left/></button>}
      <div className={cn(styles.check_email,
        styles.check_email_toolip)}>
        <img src={toolip_img_url('check_email.png')} width={152}
          height={128} className={styles.img}/>
        <div className={styles_common.head}>
          {props.img_set=='toolip' ?
            <p className={styles_common.login_signup_text}><b>Check your
              email</b></p> :
            <p className={cn(theme.med, theme.color_n700, styles.m24)}>
              Check your email</p>}
        </div>
        <div className={styles.pad_content}>
          <p className={cn(theme.p3, theme.reg, styles.text)}>
            If your email is already linked to
            an {props.img_set == 'toolip' ? 'Toolip' : 'Hola'} account, you
            will need to reset your password.<br/><br/>
            Please check your email inbox, spam or junk folders for
            instructions.
          </p>
          <Button caption={'Got it'} color={'white'} round={false}
            on_click={()=>props.go_to('login_buttons')}/>
        </div>
      </div>
    </div>;
};

export const State_reset_password = (props: i_reset_password_props)=>{
    const {theme} = useContext(Settings_context);
    const [email, set_email] = useState('');
    const [error, set_error] = useState('');
    const [loading, set_loading] = useState(false);
    const send = event=>{
      event.preventDefault();
      perr({id: 'www_password_reset_click', info: {email}});
      etask(function*(){
          if (!is_valid_email(email))
              return set_error('Please enter a valid email address');
          set_loading(true);
          try {
              let res = yield fetch('/users/send_reset_password_mail', {
                  method: 'POST',
                  body: {email, ajax: 1},
                  json: 1,
              });
              if (!res || !res.sent)
                  throw Error('send password reset failed');
              perr({id: 'www_password_reset_sent', info: {email}});
              set_loading(false);
              props.go_to('reset_password_done');
          } catch(e){
              console.error(e);
              set_error(e.text);
              set_loading(false);
          }
      });
  };
    return <div className={styles.root}>
      <button
        className={styles_common.back_btn_in_corner} onClick={()=>{
          props.go_to('login_with_email', -1);
        }}><Chevron_left/></button>
      <div className={styles.form_block}>
        <form className={styles.pad_content}>
          <Fragment>
            <img src={toolip_img_url('reset_password.png')} width={206}
            height={97} className={styles.img_toolip}/>
            <p className={cn(theme.med, theme.color_n700, styles.m24)}>
              Forgot password?</p>
          </Fragment>
          <p className={cn(theme.p3, theme.reg, styles.text)}>
            Enter the email address associated with your account. We'll email
            you a link to reset your password</p>
          <Input label={'Email'} placeholder={'Enter your email'}
            on_change={v=>{
              set_email(v);
                set_error('');
            }} value={email}
            error={error}
            on_blur={()=>{
              if (!is_valid_email(email))
                return set_error('Please enter a valid email address');
              set_error('');
            }}
          />
          <Button caption={<Fragment>
            Send reset link
            <Icon_arrow_right/>
            </Fragment>}
            color={'black'} round={false}
            disabled={!!error || loading} cls={styles.reset_button}
            on_click={send}
            size={props.img_set == 'toolip' ? 'lg' : 'md'}/>
        </form>
      </div>
    </div>;
};
